import mainePage from './mainPage.json'

export default {
    mainePage
}


// WEBPACK FOOTER //
// ./src/locale/en/index.js